import { d as m } from "../../vendor-CPVnY93G.js";
import "react/jsx-runtime";
import "react";
import { getSpacingClasses as d } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index10.css';const a = "_baseButton_6s1s7_1", i = "_sm_6s1s7_28", p = "_md_6s1s7_33", u = "_primary_6s1s7_39", y = "_secondary_6s1s7_53", g = "_ghost_6s1s7_54", B = "_destructive_6s1s7_81", s = {
  baseButton: a,
  sm: i,
  md: p,
  primary: u,
  secondary: y,
  ghost: g,
  destructive: B
}, f = ({ size: t, variant: o, m: _, mt: c, mr: r, mb: e, ml: n }) => m(
  s.baseButton,
  t ? s[t] : void 0,
  o ? s[o] : void 0,
  d({ m: _, mb: e, ml: n, mr: r, mt: c })
);
export {
  f as getButtonStyles
};
